
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doAdd: { api: 'M0120ClassroomService.M20201_doAdd'},
    getEdit: { api: 'M0120ClassroomService.M20201_getEdit'},
    doEdit: { api: 'M0120ClassroomService.M20201_doEdit'},
    doRead: { api: 'M0120ClassroomService.M20201_doRead'},
    doDelete: { api: 'M0120ClassroomService.M20201_doDelete'},
    doBrowse: { api: 'M0120ClassroomService.M20201_doBrowse'},
  },
}

const module = {
  state: {
    PageConst,
    dropdownList: {
      centers: []
    },
    defaultDoBrowse: {
      searchInfo: {
        search: '',
        delete_flag: 0, // Default to '有効な教室'
      },
      orderBy: {},
      doBrowseStatus: 'init'
    },
  },

  getters: {},

  mutations: {},

  actions: {
    async M20201_doBrowse_init ({ state, commit, rootState,dispatch }) {
      const centers = rootState.Auth.m0110Center_Authority || [];
      commit('setState', {
        dropdownList: {
          centers
        }
      });
    },
    async M20201_doBrowse_AtDataTable({dispatch, state}) {
      return await dispatch('doBrowse_AtDataTable', {
        orderBy: state.orderBy,
        pagination: state.pagination
      });
    },
    async M20201_exportCSV ({ state }) {
      const res = await $this.$api.postData({
        data: [{
          api: 'M0120ClassroomService.M20201_exportCSV',
          input: { searchInfo: state.searchInfo, orderBy: state.orderBy }
        }]
      })
      return res[0].output;
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
